// --- CONFIGURAÇÃO DO GRID ---

export const DRAM_LONG_DATES_GROUP_LAYOUT = "repeat(5, 140px)"; // 5 grupos de 140px (70px + 70px)
export const DRAM_SHORT_DATES_GROUP_LAYOUT = "repeat(6, 140px)"; // 5 grupos de 140px (70px + 70px)
export const PAIR_LAYOUT = "67px 67px"; // Layout interno de cada par (Planejado/Entregue)
export const DRAM_LONG_DATES_GAP = "20px"; // Ajuste esse valor para aumentar/diminuir o espaçamento entre os blocos

export const DRAM_LONG_GRID_LAYOUT = "minmax(200px, 1fr) max-content 90px";
export const GRID_LAYOUT = DRAM_LONG_GRID_LAYOUT;
export const GRID_LAYOUT_SELECTION_MODE_ON = `48px ${GRID_LAYOUT}`;
export const ADDENDUM_GRID_LAYOUT = "460px 1fr 90px";
export const ADDENDUM_DATE_COL_WIDTH = "250px";

export const getGridTemplate = (isSelectionMode) =>
  isSelectionMode ? GRID_LAYOUT_SELECTION_MODE_ON : GRID_LAYOUT;

export const DRAM_LONG_HEADER_GROUPS = [
  { title: "ENTREGA", planningKey: "delivery", realizedKey: "delivery" },
  {
    title: "PARECER CONTEÚDO",
    planningKey: "contentAssessment",
    realizedKey: "contentAssessment",
  },
  {
    title: "PARECER DIVERSIDADE",
    planningKey: "diversityAssessment",
    realizedKey: "diversityAssessment",
  },
  {
    title: "LIBERAÇÃO",
    planningKey: "release",
    realizedKey: "channelRelease",
  },
  {
    title: "NOTES DO CANAL",
    planningKey: "channelNotes",
    realizedKey: "channelNotes",
  },
];

export const DRAM_SHORT_HEADER_GROUPS = [
  { title: "ENTREGA", planningKey: "delivery", realizedKey: "delivery" },
  {
    title: "PARECER CONTEÚDO",
    planningKey: "contentAssessment",
    realizedKey: "contentAssessment",
  },
  {
    title: "PARECER PRODUÇÃO",
    planningKey: "productionAssessment",
    realizedKey: "productionAssessment",
  },
  {
    title: "PARECER DIVERSIDADE",
    planningKey: "diversityAssessment",
    realizedKey: "diversityAssessment",
  },
  {
    title: "LIBERAÇÃO",
    planningKey: "release",
    realizedKey: "channelRelease",
  },
  {
    title: "NOTES DO CANAL",
    planningKey: "channelNotes",
    realizedKey: "channelNotes",
  },
];

// Retorna a configuração de grupos de acordo com o schedulerType do PlanningGrid
export function getSchedulerConfig(schedulerType) {
  const normalizedType = schedulerType?.trim().toLowerCase();

  if (normalizedType === "materiais") {
    return {
      headerGroups: DRAM_SHORT_HEADER_GROUPS,
      headerGroupsDatesLayout: DRAM_SHORT_DATES_GROUP_LAYOUT,
    };
  }

  return {
    headerGroups: DRAM_LONG_HEADER_GROUPS,
    headerGroupsDatesLayout: DRAM_LONG_DATES_GROUP_LAYOUT,
  };
}
